import { computed } from 'vue'

import type { KanbanLogActor } from '@entities/kanban-comment'

import { useAdminRoutes } from '@shared/lib/routes'

interface KanbanLogCreatorPayload {
  creator: KanbanLogActor | null | undefined
}

interface CreatorRef {
  name: string
  url: string
}

interface KanbanLogCreatorReturn {
  refCreator: ComputedRef<CreatorRef | null>
}

export const useKanbanLogCreator = (payload: KanbanLogCreatorPayload): KanbanLogCreatorReturn => {
  const refCreator = computed<CreatorRef | null>(() => {
    if (!payload.creator) return null
    return {
      name: payload.creator.name,
      url: useAdminRoutes('admin.user.show', { user_id: payload.creator.id }) ?? '',
    }
  })

  return {
    refCreator,
  }
}